import {KTCard} from '../../../../../template/_metronic/helpers'
import {HistoryListCard} from './HistoryListCard'
import {HistoryFilters} from './table/filters/HistoryFilter'
import {TitleCard} from '../../../../../helpers/elements/card/TitleCard'
import {useDispatch, useSelector} from 'react-redux'
import {setCompletedBatchFilter} from '../../../../../redux/slices/completedBatchFilterSlice'
import {RootState} from '../../../../../redux/store'

const HistoryList = () => {
  const dispatch = useDispatch()
  const currentCompletedBatchFilter = useSelector(
    (state: RootState) => state.completedBatchFilterSlice
  )

  return (
    <>
      <TitleCard title='Pagos realizados' subtitle='Listado de pagos'>
        <button
          className='btn btn-primary'
          onClick={() => {
            dispatch(
              setCompletedBatchFilter({
                ...currentCompletedBatchFilter,
                page: 1,
                timestamp: new Date().getTime().toString(),
              })
            )
          }}
        >
          Refrescar
        </button>
      </TitleCard>
      <div className='mb-8'>
        <HistoryFilters />
      </div>
      <HistoryListCard />
    </>
  )
}
export {HistoryList}
